import React from 'react'
import styled from 'styled-components'
import Accordion from '../../components/Accordion'
import SummativePracticalAssessmentPanel from './SummativePracticalAssessmentPanel'

const StyledAccordion = styled(Accordion)`
  height: calc(100% - 36px);
  overflow-y: auto;
`
const SectionHeader = styled.div`
  padding: 0.5em;
  border: 1px solid black;
  background-color: ${({ theme }) => theme.main};
  .mdl-textfield {
    padding: 4px 0;
  }
  input {
    font-size: 1.5em;
  }
`

export default function SummativePracticalAssessments({
  updateSummativePractical,
  removeSummativePractical,
  summativePracticals,
  updateSummativePracticalMapping,
  copySummativePractical,
}) {
  return (
    <StyledAccordion
      data={summativePracticals}
      headerComponent={({ name, ...restProps }) =>
        <SectionHeader {...restProps}>
          {name}
        </SectionHeader>}>
      {summativePracticals.map((summativePractical, i) =>
        <SummativePracticalAssessmentPanel
          key={i}
          summativePractical={summativePractical}
          updateSummativePractical={updateSummativePractical}
          removeSummativePractical={removeSummativePractical}
          updateSummativePracticalMapping={updateSummativePracticalMapping}
          copySummativePractical={copySummativePractical}
          index={i}
        />,
      )}
    </StyledAccordion>
  )
}



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/SummativePractical/SummativePracticalAssessments.js